import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "London 5",
  "description": "",
  "published": "2007-09-26T00:00:00.000Z",
  "redirect_from": ["/blog/london-5/swizec/151"],
  "categories": "travel",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Oh but I have been neglecting you my lovelies haven't I? It's all for a good reason and I should be able to apologize, but you know, I don't do that. So let's just get on with it as if I did post on each day of the last three.`}</p>
    <p>{`Yesterday I went to see Cabaret with the loveliest of things last night. I'm not quite certain because of which the evening was the best I've ever had, but let's, for my own safety, say it was because of the play. The young thing is taken after all and I'm a man of honour.`}</p>
    <p>{`Cabaret was probably the best live performance I've ever seen in my life. It was just marvelously magnificent and I suggest everyone to go and watch it. You must! There's a lot of singing and dancing and even quite some nudity, both male and female, but us theatre goers find that rather normal by now. Nudity everywhere. I laughed almost the whole evening away and I will most assuredly go see the slovene version when I come home.`}</p>
    <p>{`The lovely young thing I mentioned was Peaches, my long time chatslave person from england and I have to admit meeting her would be more awkward, but it all went as if we'd been long time real life buddies who just so happened not to have seen each other in two days. Really, there's more awkwardnes meeting my buddies after a week or two.`}</p>
    <p>{`Should've taken a photo ...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      